import { render, staticRenderFns } from "./multi-banner.vue?vue&type=template&id=27d44b77&scoped=true&"
import script from "./multi-banner.vue?vue&type=script&lang=js&"
export * from "./multi-banner.vue?vue&type=script&lang=js&"
import style0 from "./multi-banner.vue?vue&type=style&index=0&id=27d44b77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d44b77",
  null
  
)

export default component.exports